import React, { Component } from 'react'
import { Button, Form, Input, Upload, Icon, Switch } from 'antd'
import {connect} from 'dva'
import {Link} from 'dva/router'
import { message } from 'antd'
import config from '../../utils/config'
import InputMask from 'react-input-mask';
import { get, create } from '../../services/restApi'
import PropTypes from 'prop-types'
var IconAwesome = require('react-fontawesome');
const _ = require('underscore')

const FormItem = Form.Item;

class UserNew extends Component {

    constructor (props) {
        super(props);

        this.state = {
            imageUrl: '',
            file: {},
            loading: false,
            user: {}
        }

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        if (this.props.params.userId) {
            this.props.dispatch({type: 'app/showLoading'})

            get('_User', this.props.params.userId).then((resp) => {

                this.props.form.setFieldsValue(resp);
                this.setState({ user: resp });

                if (resp.picture) {
                    this.setState({ imageUrl: config.externalUrl + 'uploads/users/' + resp.picture });
                }
                this.props.dispatch({type: 'app/hideLoading'})
            })
        }
    }


    /**
    * Codifica la imagen al formato Base64
    */
    getBase64 (img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }


    /**
    * Validación antes de subir la imagen
    */
    beforeUpload (file) {
        const isJPEG = file.type === 'image/jpeg';
        const isJPG = file.type === 'image/jpg';
        const isPNG = file.type === 'image/png';
        if (!isJPG && !isJPEG && !isPNG) {
            message.error('El formato de la imagen is inválido!');
        }

        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('La imagen debe ser menor a 2MB!');
        }

        this.setState({file: file, loading: true});
        return (isJPG || isJPEG || isPNG) && isLt2M;
    }


    /**
    * Visualiza la imagen preview subida
    */
    handlePictureChange (info) {
        if (info.file.status === 'done') {
            this.getBase64(info.file.originFileObj, imageUrl => this.setState({ imageUrl }));
            this.setState({loading: false});
        }
    }


    /**
    * Validator: Checa el username sin espacios
    */
    checkUsername (rule, value, callback) {
        if (value && /\s/.test(value)) {
            callback('Verifique que el usuario no contenga espacios!');
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa el correcto formato del teléfono
    */
    checkPhone (rule, value, callback) {
        if (value && value.replace(/[^\d.]/g, '').length < 10) {
            callback('Por favor, ingrese un número de teléfono válido!');
        } else {
            callback();
        }
    }


    /**
    * Envío del formulario
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            if (values.phone)
                values.phone = values.phone.replace(/[^\d.]/g, '');

            if (values.mobile_phone)
                values.mobile_phone = values.mobile_phone.replace(/[^\d.]/g, '');

            if (this.state.file.uid)
                values.picture = this.state.file.uid + '.jpg';
            
            if (!this.props.params.userId) {
                // CREA
                //this.props.dispatch({type: 'user/create', payload: values})

                // Model
                let data = {...values};
                data.type = 'administrador';
                data.active = true;

                this.props.dispatch({type: 'app/showButtonLoading'})

                create('_User', data).then(resp => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})
                    message.success('Se ha creado el usuario exitosamente');

                    this.props.form.resetFields();
                    this.props.form.setFieldsValue({phone: '', mobile_phone: ''})
                    this.setState({imageUrl: ''})

                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });

            } else {
                // ACTUALIZA

                _.extend(this.state.user, values);
                this.props.dispatch({type: 'user/update', payload: this.state.user})
                this.context.router.goBack();
            }
        })
    }


    /**
    * Render del componente
    */
    render () {
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        <Link to="/all_users/list-users"><i className="fa fa-arrow-circle-left"></i></Link>
                        Usuario
                    </h1>
                </section>

                <section className="content">
                    <Form onSubmit={this.handleSubmit.bind(this)}>
                        <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                            <div className="box-header with-border">
                                Datos del Nuevo Usuario
                            </div>

                            <div className="box-body">
                                <div className="row">
                                    {this.props.params.userId
                                        ? <div className="col-md-12">
                                            Status: <FormItem hasFeedback>
                                                {this.props.form.getFieldDecorator('active')(
                                                    <Switch checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} checked={this.props.form.getFieldValue('active')} />
                                                )}
                                            </FormItem>
                                        </div>
                                        : ''
                                    }

                                    <div className="col-md-2">
                                        <label>Foto de perfil <small>(opcional)</small></label>
                                        <Upload
                                            className="avatar-uploader"
                                            name="file"
                                            accept="image/*"
                                            showUploadList={true}
                                            action={config.externalUrl + "includes/upload.php"}
                                            beforeUpload={this.beforeUpload.bind(this)}
                                            onChange={this.handlePictureChange.bind(this)}
                                            headers={{
                                                "X-Parse-Application-Id": config.appId
                                            }}
                                            data={{
                                                type: 'user',
                                                custom_name: this.state.file.uid + '.jpg'
                                            }}
                                        >
                                            {this.state.imageUrl ?
                                                <img src={this.state.imageUrl} alt="" className="avatar" /> :
                                                this.state.loading ? 
                                                    <IconAwesome name="refresh" spin className="spin-uploader" />
                                                    : <Icon type="plus" className="avatar-uploader-trigger" />
                                            }
                                        </Upload>
                                    </div>

                                    <div className="col-md-10">
                                        { this.state.user && !this.state.user.objectId
                                            ? <div>
                                                <div className="col-md-4">
                                                    <FormItem label="Usuario" hasFeedback>
                                                        {this.props.form.getFieldDecorator('username', {
                                                            rules: [{
                                                                required: true,
                                                                message: 'Por favor, ingrese el nombre de usuario'
                                                            }, {
                                                                validator: this.checkUsername.bind(this)
                                                            }]
                                                        })(<Input size='large' onPressEnter={this.handleSubmit.bind(this)} />)}
                                                    </FormItem>
                                                </div>

                                                <div className="col-md-4">
                                                    <FormItem label="Contraseña" hasFeedback>
                                                        {this.props.form.getFieldDecorator('password', {
                                                            rules: [{
                                                                required: true,
                                                                message: 'Por favor, ingrese la contraseña'
                                                            }]
                                                        })(<Input type="password" size='large' onPressEnter={this.handleSubmit.bind(this)} />)}
                                                    </FormItem>
                                                </div>
                                            </div>
                                            : ''
                                        }


                                        <div className="col-md-4">
                                            <FormItem label="Nombre completo" hasFeedback>
                                                {this.props.form.getFieldDecorator('name', {
                                                    rules: [{
                                                        required: true,
                                                        message: 'Por favor, ingrese el nombre completo'
                                                    }]
                                                })(<Input size='large' onPressEnter={this.handleSubmit.bind(this)} />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Correo electrónico" hasFeedback>
                                                {this.props.form.getFieldDecorator('email', {
                                                    rules: [{
                                                        type: 'email',
                                                        required: true,
                                                        message: 'Por favor, ingrese el correo electrónico del usuario'
                                                    }]
                                                })(<Input size='large' onPressEnter={this.handleSubmit.bind(this)} />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Teléfono" hasFeedback>
                                                {this.props.form.getFieldDecorator('phone', {
                                                    rules: [{
                                                        required: false,
                                                    }, {
                                                        validator: this.checkPhone.bind(this)
                                                    }]
                                                })(<InputMask mask="(999) 999 9999" className="ant-input ant-input-lg" />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Celular" hasFeedback>
                                                {this.props.form.getFieldDecorator('mobile_phone', {
                                                    rules: [{
                                                        required: false,
                                                        message: 'Por favor, ingrese el teléfono celular del usuario'
                                                    }, {
                                                        validator: this.checkPhone.bind(this)
                                                    }]
                                                })(<InputMask mask="(999) 999 9999" className="ant-input ant-input-lg" />)}
                                            </FormItem>
                                        </div>
                                    </div>
                                </div>

                                <div className="row text-center">
                                    <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                        Guardar
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                </section>
            </div>
        )
    }
}

UserNew.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({user, app}) => ({user, app}))(Form.create()(UserNew))


// WEBPACK FOOTER //
// ./src/components/users/userNew.js